import React from 'react';
import PropTypes from 'prop-types';
import { Paragraph } from 'components/core/Typography';
import './ReviewCard.scss';
import ReviewRating from 'components/review/Review/ReviewRating';
import { getInitials } from 'utils/format';

const ReviewCard = ({ title, stars, description, user }) => (
	<div className="review-card">
		<div className="title-section">
			<Paragraph className="review-title" size="medium">
				{title}
			</Paragraph>
			<ReviewRating reviewRating={stars} reviewRatingOutOf={5} size="large" />
		</div>
		<Paragraph className="sf-type-black" weight="standard">
			{description}
		</Paragraph>
		<Paragraph className="reviewer" last>
			<span className="initials sf-type-weight-bold">
				{getInitials(user)}
			</span>
			<span className="by-username sf-type-weight-bold"> by {user} </span>
		</Paragraph>
	</div>
);

ReviewCard.propTypes = {
	title: PropTypes.string,
	stars: PropTypes.number,
	description: PropTypes.string,
	user: PropTypes.string
};

export default ReviewCard;
